import { combineReducers } from 'redux';
import authReducer from './authReducer';
import loadingReducer from './loadingReducer';
import modelsDataReducer from './modelsDataReducer';
import formsReducer from './formsReducer';
import tablesReducer from './tablesReducer';
import createDispatchReducer from '../../Containers/Dispatch/reducer';
import { uiReducer } from '../UI/reducer';

export default combineReducers({
  auth: authReducer,
  loading: loadingReducer,
  models: modelsDataReducer,
  forms: formsReducer,
  tables: tablesReducer,
  dispatch: createDispatchReducer(),
  ui: uiReducer,
});
